import { array } from 'prop-types';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { toast } from 'react-toastify';
import { ABOUT_US, CATEGORY, REQUIRED } from '../config/apiEndPoint';
import { GET, POST, PUT } from 'config/api.config';

export const getJobRequiredList = async (data = array()) => {
    try {
        let url = data?._Id ? `${REQUIRED.GET_JOB_REQUIRED_LIST}/${data?._Id}` : `${REQUIRED.GET_JOB_REQUIRED_LIST}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

export const addJobRequired = async (data = array()) => {
    try {
        const response = await POST(REQUIRED.GET_JOB_REQUIRED_LIST, data);
        return response;
    } catch (error) {
        toast.error(error.message);
    }
};

export const updateJobRequired = async (id, data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${REQUIRED.GET_JOB_REQUIRED_LIST}/${id}`;
        const response = await PUT(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const getJobRequiredDataById = async (data = array()) => {
    try {
        let url = data?.Id ? `${REQUIRED.GET_JOB_REQUIRED_LIST}/${data?.Id}` : `${REQUIRED.GET_JOB_REQUIRED_LIST}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

export const fetchJobRequiredTableAndFilterSchema = async (data = array()) => {
    try {
        let url = data?._Id ? `${REQUIRED.GET_JOB_REQUIRED_SCHEMA}/${data?._Id}` : `${REQUIRED.GET_JOB_REQUIRED_SCHEMA}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

export const submitJobRequiredFilterData = async (data = array()) => {
    try {
        const response = await POST(REQUIRED.SUBMIT_FILTER_DATA, data);
        return response;
    } catch (error) {
        toast.error(error.message);
    }
};

